/**
 * 实名认证状态（与个人/企业 isVerified 字段一致）
 * 0 待认证、1 认证中、2 已认证、3 未通过
 */
export const RealNameAuthStatusEnum = {
  UNAUTHENTICATED: { code: '0', label: '待认证' },
  UNDER_CERTIFICATION: { code: '1', label: '认证中' },
  CERTIFIED: { code: '2', label: '已认证' },
  AUTHENTICATION_FAILED: { code: '3', label: '未通过' }
}

/** isVerified 取值常量 */
export const REAL_NAME_AUTH_STATUS = {
  UNAUTHENTICATED: RealNameAuthStatusEnum.UNAUTHENTICATED.code,
  UNDER_CERTIFICATION: RealNameAuthStatusEnum.UNDER_CERTIFICATION.code,
  CERTIFIED: RealNameAuthStatusEnum.CERTIFIED.code,
  AUTHENTICATION_FAILED: RealNameAuthStatusEnum.AUTHENTICATION_FAILED.code
}

/**
 * @param {string|number} code
 * @returns {string}
 */
export function getRealNameAuthStatusLabel(code) {
  const c = code == null ? '' : String(code)
  const hit = Object.values(RealNameAuthStatusEnum).find((item) => item.code === c)
  return hit ? hit.label : ''
}
